import { render } from "./ImageLightbox.vue?vue&type=template&id=1f6a1e74&scoped=true"
import script from "./ImageLightbox.vue?vue&type=script&lang=js"
export * from "./ImageLightbox.vue?vue&type=script&lang=js"

import "./ImageLightbox.vue?vue&type=style&index=0&id=1f6a1e74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6a1e74"]])

export default __exports__